module.exports = {"information_analysis":"Análisis de información","select_device":"Seleccionar Dispositivo","date_range":"Rango de fechas","select_var":"Seleccionar Variable","tension":"Tension","intensity":"Intensidad","cos_phi":"Coseno Phi","power_factor":"Factor Pot.","active_energy":"Energía Act.","reactive_energy":"Energía React.","max_demand":"Max. Demanda","active_power":"Potencia Act.","harmonic_intensity":"Armónico Int.","harmonic_tension":"Armónico Ten.","graphic":"Gráfico","table":"Tabla","info_to_export":"Información a Exportar","maximeter_historical":"Histórico maxímetro"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/ExportData.json
// module id = 602
// module chunks = 1